export default __webpack_public_path__ + "static/media/serv_hosting.1fe14bda.jpg";